import { PatientTaskInstanceId } from "../../shared/schema/schema";
import { createQueryKeys } from "../../shared/utils/create-query-keys";

export const patientTaskMetricsQueryKeys = createQueryKeys("patient_task_metrics", {
  search: (params: Record<string, unknown>) => params,
  getCount: (id: PatientTaskInstanceId) => id,
  metrics: null,
});
